module.exports = __webpack_public_path__ + "static/WEDDING E&M-472-e9f68df731c0b705c392cd1aeb7a4c8a.jpg";